import * as React from 'react';
import { toast } from 'react-toastify'
import * as request from 'superagent';

export namespace RetrievePassword {
    export interface Props {
        match: {
            params: {
                id: string
            }
        }
    }

    export interface State {
        keyIsValid: boolean;
    }
}

export default class RetrievePassword extends React.Component<RetrievePassword.Props, RetrievePassword.State> {
    password: HTMLInputElement;
    passwordAgain: HTMLInputElement;
    newPasswordKey: string;

    constructor(props) {
        super(props);

        this.setIsKeyValid = this.setIsKeyValid.bind(this);

        this.newPasswordKey = this.props.match.params.id;
        this.setIsKeyValid(this.newPasswordKey);

        this.state = {
            keyIsValid: false
        }
    }

    setIsKeyValid(newPasswordKey: String): void {
        request
            .post('/user/forgotPassword/isKeyValid')        
            .set('Content-Type', 'application/json')
            .send({newPasswordKey})
            .then((response) => {
                this.setState({keyIsValid: true});
            })   
            .catch((err) => {
                this.setState({keyIsValid: false});
            })      
    }

    sendRequest(e: any) {
        e.preventDefault;

        const password = this.password.value,
                passwordAgain = this.passwordAgain.value,
                newPasswordKey = this.newPasswordKey;

        if(password !== passwordAgain) toast.error('Passwords must match.');
        else {
            request
            .post('/user/forgotPassword')        
            .set('Content-Type', 'application/json')
            .send({password, newPasswordKey})
            .then((response) => {
                toast.success('Salasanan vaihtaminen onnistui.');
            })   
            .catch((err) => {
                toast.error('Käyttäjätunnusta tai sähköpostiosoitetta ei löytynyt.');
            })      
        }
    }

    render() {
        const message = this.state.keyIsValid ? ( 
            <div className="alert alert-info">Anna uusi salasana.</div>
        ) : (
            <div className="alert alert-danger">Linkki ei ole enää voimassa.</div>
        );

        return (
                <div className="jumbotron am_teachercontainer col-6 offset-3 am_shadow mt-5">
                    {message}
                    <form className="form-group" id="am_retriewepassword" onSubmit={this.sendRequest}>
                        <input ref={(input) => this.password = input} className="col-12 form-control mb-1" placeholder="Salasana" />
                        <input ref={(input) => this.passwordAgain = input} className="col-12 form-control mb-1" placeholder="Salasana uudestaan" />
                        <button type="submit" className={"col-12 btn form-control am_green-button am_shadow mb-1"}>LÄHETÄ</button>
                    </form>
                </div>
        )
    }
};


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Common/retvievePassword.tsx